import {
  DimeAvatar,
  DimeAvatarFallback,
  DimeButton,
  DimeInput,
  DimeSidebarTrigger,
  DimeTooltip,
} from '@nudool/design-system';
import { Search } from 'lucide-react';

import { AppBreadcrumbs } from './AppBreadcrumbs.js';
import { userInitials } from './user-initials.js';
import { userLabel } from './user-label.js';

type AppHeaderProps = Readonly<{
  firstName?: string | null;
  lastName?: string | null;
  email?: string | null;
}>;

export function AppHeader({ firstName, lastName, email }: AppHeaderProps) {
  const initials = userInitials(firstName, lastName, email);
  const label = userLabel(firstName, lastName, email);
  return (
    <header className="sticky top-0 z-20 flex h-14 shrink-0 items-center gap-3 border-b border-border bg-background px-4">
      <div className="flex min-w-0 flex-1 items-center gap-3">
        <DimeSidebarTrigger />
        <AppBreadcrumbs />
      </div>

      <div className="relative hidden w-full max-w-sm md:block">
        <Search
          aria-hidden
          className="pointer-events-none absolute top-1/2 left-3 size-4 -translate-y-1/2 text-muted-foreground"
        />
        <DimeInput
          showClear={false}
          aria-label="Search"
          className="h-9 pr-14 pl-9"
          disabled
          placeholder="Search customers, orders..."
        />
        <span
          aria-hidden
          className="pointer-events-none absolute top-1/2 right-3 -translate-y-1/2 rounded border border-border px-1.5 py-0.5 text-[10px] font-medium text-muted-foreground"
        >
          ⌘K
        </span>
      </div>

      <DimeTooltip content={label} side="bottom">
        <DimeButton
          variant="ghost"
          size="icon"
          className="size-8 shrink-0 rounded-full p-0"
          aria-label={label}
        >
          <DimeAvatar className="size-8">
            <DimeAvatarFallback className="text-xs font-semibold">{initials}</DimeAvatarFallback>
          </DimeAvatar>
        </DimeButton>
      </DimeTooltip>
    </header>
  );
}
